import React, { useContext } from 'react';
import { Box, Image } from '@honda-canada/design-system-react';

import FooterContext from '../service/FooterContext';
import RoutableSitecoreLink from '../../RoutableSitecoreLink';
import themeStyles from '../Footer.styles';

const Logo = themeStyles.apply(Box, 'Logo');

const LogoImage = () => {
  const { siteLogo, styles } = useContext(FooterContext);

  return (
    <Logo as={RoutableSitecoreLink} field={siteLogo?.headerUrl} data-testid="cy-footer-logo" {...styles?.logo}>
      <Image {...siteLogo?.siteLogo} />
    </Logo>
  );
};

export default LogoImage;
